import $filter from '../combine-filter';
import {AutoTableController, EDIT_STATUS} from "./index";
import {getSecurity} from "../micro.compatible";

const REQUEST_TYPE = {
	queryByExamplePage: 'queryByExamplePage',
	insert: 'insert',
	update: 'update',
	deleteById: 'deleteById',
	batchInsert: 'batchInsert',
	batchUpdate: 'batchUpdate',

	queryCount: 'queryCount',
	exportData: 'exportData',
	defaultNewRow: '',
}

/**
 * 默认各种请求是否需要格式化请求参数为表单参数
 * @author  韦胜健
 * @date    2019/1/22 10:41
 */
const DEFAULT_FORMAT_PARAM_SETTING = {
	queryByExamplePage: true,
	queryCount: true,
	exportData: true,
	insert: false,
	update: false,
	deleteById: false,
	batchInsert: false,
	batchUpdate: false,
}
/**
 * 默认查询参数
 * @author weishengjian
 * @date 2018/11/17
 */
const DEFAULT_QUERY_PARAM = {
	page: 1,                                                                                //当前页
	pageFlag: true,                                                                         //是否为分页查询
	onlyCountFlag: false,                                                                   //是否需要查询总数
	// oauth: 'ALL',                                                                        //数据安全性
	filtersRaw: [],                                                                         //筛选参数数组
};

/**
 * 默认公共参数
 * @author  韦胜健
 * @date    2019/1/12 14:06
 */
function getDefaultPublicOption() {
	return {
		indexing: true,                                                                        //自动添加索引列
		singleSelect: true,                                                                    //是否单选
		showHeader: true,                                                                      //筛选框
		showFooter: true,                                                                      //分页框
		buttons: [],
		requestMethod: 'post',                                                                 //分页查询采用post请求的方式
		sortField: 'created',
		sortDesc: true,
		insertButton: true,
		copyButton: true,
		deleteButton: true,
		importButton: false,
		combineSearchButton: true,
		showMoreRowsButton: true,
		showCountsButton: true,
		showRecordDetailButton: true,
		copyExcludeKey: ['id', 'created', 'lastUpdated', 'createdBy', 'lastUpdatedBy', 'basicOrgId', 'basicPostnId', 'login', 'loginCorpId', 'corpid', 'orgId', 'postnId'],
		showFilterBar: true,
		showMoreButton: true,
		searchBarSearchButton: true,
		quickfilterType: 'check',
		searchSelectWidth: 120,
		editType: 'inline',
		selectFirstOnLoad: true,
		// searchBarSearchIcon: true,
		settingButton: true,
		saveAndCreateButton: true,
		standardButtonDisabled: {},
		formFilterShow: false,
		formFilterWidth: '100%',
		fixedRowText: LinkVue.$t('LinkAutoTable.summary'),
		defaultSearchIdField: true,
		columnFilter: true,
		availablePageNum: 3,
		formEditLabelWidth: 'auto',
		selectCache: true,
		// onlyUpdateChangeField: true,
		sizeOption: [10, 20, 50, 100],                                                         //分页查询页大小配置项
		showPageCount: true,																   // 是否显示分页栏右侧统计区域
		allowFreshOnBack: true																   // 是否允许tab页回退时的自动刷新请求
	}
}

/**
 * LinkAutoTable的默认参数
 * @author weishengjian
 * @date 2018/11/22
 */
const DEFAULT_OPTION_AUTO_TABLE = {
	insertable: true,                                                                      //可新建
	updateable: true,                                                                      //可编辑
	batchUpdateable: true,                                                                 //可批量编辑
	deleteable: true,                                                                      //可删除
	copyable: false,                                                                       //可复制
	exportable: true,                                                                      //可导出
	importable: false,                                                                     //可导入
	loadOnStart: true,                                                                     //是否在初始化的时候就自动加载数据
	showPageNum: true,
	bodyRowHeight: 40,
	batchModifyButton: true,
	formEditButton: true,
	storeFilterButton: true,
	showNum: 10,                                                                            // showNumTable显示行数的高度，这个默认参数只能给AutoTable设置，$object服务不能设置，因为 $object 默认使用适配屏幕高度的行数
	disabledColumnFilter: false,														    // 是否禁用掉表格的所有列筛选 默认不禁用
}

/**
 * LinkObjectModal的默认参数(选择对象的时候的默认参数)
 * @author weishengjian
 * @date 2018/11/22
 */
const DEFAULT_OPTION_OBJECT_PICK = {
	showPageNum: false,
	bodyRowHeight: 32,
	checkOnClickRow: true,
}

/**
 * auto-table组件的配置参数对象
 * @author weishengjian
 * @date 2018/11/17
 */

/*----注意，AutoOption一律只能在data中创建，不要在method中多次创建，比如在某个method方法中这么写是不行的：this.$object.pick({option:new AutoOption({...})})----*/

const component = {
	data() {
		const pageData = {
			showPage: null,                                                                     //pageData.page的一个缓存变量
			option: this,
			/*@formatter:on*/
			total: 1,                                                                           //总记录数
			noMore: false,                                                                      //是否已经查询总数
			/*@formatter:off*/
            get totalSize() {return this.total},                                                //总记录数
            get page() {return this.option.param.page},                                         //当前页
            set page(val) {this.option.param.page = val},
            get pageSize() {return this.option.param.rows || this.option.showNum || 10},        //当前页大小
            set pageSize(val) {this.option.param.rows = val},
            get totalPage() {return Math.ceil(this.totalSize / this.pageSize)},              //总页数
        }

        return {
            /**
             * 一下属性为可配置的属性
             * @author weishengjian
             * @date 2018/11/21
             */

            module: null,                                                                                  //请求地址模块地址，比如:link/clue，在没有配置queryByExamplePage的情况下，
                                                                                                           //queryByExamplePage的地址为：link/clue/queryByExample
            /*---------------------------------------请求地址汇总-------------------------------------------*/
            queryByExamplePage: null,                                                                      //分页查询地址
            insert: null,                                                                                  //新建记录地址
            update: null,                                                                                  //更新记录地址
            deleteById: null,                                                                              //删除记录地址
            queryCount: null,                                                                              //查询总数地址
            exportData: null,                                                                              //导出地址
            batchInsert: null,                                                                             //批量新建地址
            batchUpdate: null,                                                                             //批量更新地址

            /*---------------------------------------表格业务属性汇总（给auto-table使用的属性）-------------------------------------------*/
            context: null,                                                                                 //vue component，AutoOption所属上下文
            tableId: null,                                                                                 //用来做表格个性化存储的id，这个id可以通过在浏览器控制台调用getAutoTableId()函数获取，会得到一个形如1550198595220的字符串，这个属性只要保证在一个页面内所有option的tableId都不相同即可
            indexing: null,                                                                                //自动添加索引列
            title: null,                                                                                   //表格标题，没有则不显示标题
            showNum: null,                                                                                 //表格固定高度，显示的行数
            bodyRowHeight: null,                                                                           //行高
            selectIndex: null,                                                                             //当前选中的行索引
            selectCache: null,                                                                             // 表格翻页时是否缓存上一页的选中结果
            sortField: null,                                                                               //排序字段
            sortDesc: null,                                                                                //排序方式，先序还是降序
            searchField: null,                                                                             //默认搜索列字段
            singleSelect: null,                                                                            //是否单选
            render: null,                                                                                  //渲染表格内容的渲染函数
            sizeOption: null,                                                                              //分页查询页大小配置项
            fixedRowText:null,                                                                             //固定行，索引列显示文本，默认为【合计】
            disabledBodyScroll:null,                                                                       //禁用表体滚动
            availablePageNum:null,                                                                         //分页栏可见页数，默认是3，表示左右两边最多显示三个页按钮
            formEditLabelWidth:null,                                                                       //表单编辑时，表单项文本宽度
            formEditDialogProps:null,                                                                      //表单编辑时，dialog的属性对象参数
            batchModifyDialogProps:null,                                                                   //批量修改时，dialog的属性参数

            parentOption: null,                                                                            //父表option
            map: null,                                                                                     //示例{headId:'id'},表示当前查询的记录中的headId字段等于父表选中row的id字段，在查询的时候，会
                                                                                                           //  自动添加该筛选条件到filtersRaw中，如{id:'headId',property:'headId',operator:':',value:parentRow['id']}
                                                                                                           //  注意：如果是要预置筛选参数，请写在param中，不要在这里配置，因为这个map中的值会被当做key对待，从parentRow中取值当做value
                                                                                                           //  在新建row的时候，也会根据这个map规则设置newRow的一些属性，比如这里newRow.headId : parentRow.id
            searchSelectWidth: null,                                                                       //搜索栏字段下拉选择框宽度，默认96，单位像素
            editType: null,                                                                                //编辑方式，inline：行内编辑，form：弹框表单编辑
            defaultEnableEditable: null,                                                                   //默认可编辑
			editableFunc:null,																			   //可编辑统一控制函数
			requiredFunc:null,																			   //必填统一控制函数

            /*---------------------------------------请求前后事件-------------------------------------------*/
            click: null,																					// 单击行
            dblclick: null,																					// 双击行
            beforeLoad: null,																				// 加载数据前置钩子
            afterLoad: null,																				// 加载数据后置钩子
            beforeInsert: null,																				// 发送请求保存新建数据前置钩子
            beforeUpdate: null,																				// 发送请求保存编辑数据前置钩子
            beforeUpsert: null,  																			// 发送请求保存新建或者编辑的数据前置钩子
            beforeDelete: null,																				// 发送请求删除数据的前置钩子
            afterInsert: null, 																				// 新建成功后置钩子
            afterUpdate: null,																				// 编辑成功后置钩子
            afterUpsert: null,																				// 新建或者编辑成功后置钩子
            afterDelete: null,																				// 删除成功后置钩子
            beforeExportData: null,																			// 导出数据之前的钩子
            afterExportData: null,																			// 导出数据之后的钩子

            beforeEnableUpdate: null,																		// 准备开始编辑的前置钩子
            beforeEnableDelete: null,																		// 准备开始删除的前置钩子
            beforeEnableCreate: null,																		// 准备开始新建的前置钩子
			beforeCancel:null,																				// 取消的钩子。新建、编辑、批量编辑多行选择取消都会触发这个钩子

            /*---------------------------------------按钮或者功能可用性-------------------------------------------*/
            insertable: null,                                                                              //可新建
            updateable: null,                                                                              //可编辑
			customUpdate: null,                                                                            //禁用双击行编辑时自定义调用行编辑功能
            deleteable: null,                                                                              //可删除
            copyable: null,                                                                                //可复制

            enable: null,                                                                                  //是否启用表格功能，可以是true表示不禁用，false禁用，Function则动态控制禁用，禁用则相关功能不可用，按钮消失。
                                                                                                           //function的返回值是一个对象：{insertable:true,updateable:true,deleteable:true}，缺少某个属性则按照默认设置处理
            disabled:null,                                                                                 //是否禁用表格所有按钮，true|false，Function则动态控制，返回值true|false
            standardButtonDisabled: null,                                                                  //标准按钮disabled属性，该属性控制参考buttons属性介绍；示例standardButtonDisabled:{insertButton:false,deleteButton(){},}


            batchUpdateable: null,                                                                         //可批量编辑更新
            batchInsertable: null,                                                                         //可批量新增

            exportable: null,                                                                              //可导出
            importable: null,                                                                              //可导入

            showHeader: null,                                                                              //筛选框
            showFooter: null,                                                                              //分页框
            showFilterBar: null,                                                                           //是否展示搜索框
            showMoreButton: null,                                                                          //是否展示更多按钮
            columnFilter:null,                                                                             //是否启用列筛选功能
            fill: null,                                                                                    //是否自动填满父元素
            showPageNum: null,                                                                             //分页栏是否显示数字
            beforeCheck: null,                                                                             //多选勾选前置钩子函数，拒绝勾选返回Promise.reject
			beforeUncheck:null,																			   //多选的时候，取消勾选前置钩子函数，拒绝取消勾选返回Promise.reject
            checkOnClickRow: null,                                                                         //多行选择，是否在点击行的时候，选中当前行
            disabledDblClick: null,                                                                        //禁用双击编辑

            /*---------------------------------------一下为按钮相关-------------------------------------------*/
            insertButton: null,                                                                            //标准新建按钮
            copyButton: null,                                                                              //标准复制按钮
            deleteButton: null,                                                                            //标准的删除按钮
            importButton: null,                                                                            //标准的导入按钮
            combineSearchButton: null,                                                                     //标准的组合查询按钮
            settingButton: null,                                                                           //标准的设置按钮
            showMoreRowsButton: null,                                                                      //显示更多行数的按钮
            showCountsButton: null,                                                                        //显示记录计数的按钮
            showRecordDetailButton: null,                                                                  //显示记录详情的按钮
			showClearCacheButton:null,																	   //显示清空缓存的按钮
            batchModifyButton: null,                                                                       //批量修改按钮
            formEditButton: null,                                                                          //表单编辑按钮
            searchBarSearchButton: null,                                                                   //搜索栏的查询按钮
            storeFilterButton: null,                                                                       //筛选收藏按钮
            searchBarSearchIcon: null,                                                                     //筛选栏放大镜图标
            saveAndCreateButton: null,                                                                     //保存并新建按钮

            buttons: null,                                                                                 //操作表格的额外按钮数组
            /*
            {
                order:0,                    按钮排序，不写则根据类型自动设置排序序号
                type:'update',              按钮类型，用作安全性控制，会受职责安全性菜单影响，可选值：update,insert,delete
                inner:Boolean,              是否放在更多按钮下拉选项中
                label:String,               显示的文本
                needRow:Boolean,            是否需要选中一行数据
                confirm:Boolean,            是否需要确认提示
                confirmLabel:String,        确认提示信息，没有默认为：确认要进行该操作吗？
                disabled:Boolean|Function,  是否禁用
                handler:Function(row?),     点击回调函数，当needRow为true时，row参数为选中的行对象数据
            }
            */

            /*---------------------------------------auto-option自身业务属性汇总-------------------------------------------*/
            requestMethod: null,                                                                           //分页查询请求方式，get请求还是post请求
            formatFormParam: null,                                                                         //分页查询是否使用application/x-www-form-urlencoded的参数格式请求接口
            param: {},                                                                                     //查询参数
            defaultNewRow: null,                                                                           //默认新行属性值，类型为对象或者函数，函数支持promise异步返回
            defaultNewRowUrl:null,                                                                         //默认新行请求地址，返回格式{result:{},success:true}，result为newRow
            loadOnStart: null,                                                                             //是否在初始化的时候就自动加载数据
            copyExcludeKey: null,                                                                          //复制行的时候，不复制的key
            defaultId: null,                                                                               //是否需要默认id，有的列，比如mvg、图片等在记录保存之前就需要该记录的id，这时候defaultId需要被
                                                                                                           //设置为 true，这样每次点击新建的时候，都会先获取一个新的id，在编辑新行的时候id就已经存在了，如果//列表中存在 图片列、Mvg列的时候，该属性值会被自动设置为true，当开发者需要的时候，可以手动设置为true

            tableCode: null,                                                                               //要使用查看记录历史操作记录功能时，需要传入数据库中的表名，比如值列表的话，这里的值就是：lnk_list_of_val
            importCode: null,                                                                              //导入编码
            rowFormatter: null,                                                                            //对钩子函数afterLoad、afterInsert、afterUpdate、afterBatchInsert、afterBatchUpdate返回的row进行格式化的函数
            countOnReload: null,                                                                           //是否在reload的时候请求总数
            requestFunc: null,                                                                              //自定义数据请求逻辑，注意的是，返回的结果必须与后台标准接口返回的数据一致，比如queryByExamplePage返回的数据的格式是{rows, success, total}
                                                                                                            //async requestFunc(url, param, formatFormParam, requestMethod) {
                                                                                                            //  console.log(url, param, formatFormParam, requestMethod)
                                                                                                            //      return (await this.$http.axios({
                                                                                                            //          method: requestMethod,
                                                                                                            //          url,
                                                                                                            //          data: param,
                                                                                                            //          headers: {'Authorization': 'hello world'}
                                                                                                            //      })).data
                                                                                                            //},
            copyRowFormatter: null,                                                                        //触发标准复制功能的时候，对复制的数据进行格式化处理
            selectFirstOnLoad: null,                                                                       //在load之后，是否默认选中第一行
            chunkLoadData:true,                                                                             //当获取的数据超过当前显示行数+10时，是否自动分块加载数据
            fastRender:null,                                                                                //快速渲染模式，启用后渲染速度加快，编辑功能将无法使用，常用语不可编辑并显示大量数据的列表
            fixedRowData:null,                                                                             //固定行数据
            formFilterShow:null,                                                                            //表单筛选是否展开，默认展开，如果希望默认收起，则设置为false
            formFilterWidth:null,                                                                          //表单筛选的表单宽度，如果希望控制一行有少个表单元素，可以通过限制这个宽度来实现，建议要么设置100%，要么设置1000px以内，因为要兼容1366*768的屏幕
            defaultSearchIdField:null,                                                                      //搜索中是否带Id字段，为true并且列中无id字段时，自动增加id搜索字段
			/*
			*  是个数组，数组元素示例
			*  筛选普通文本：	{title: '线索名称', field: 'name', filterName: 'input', formFilter: true,}
			*  筛选值列表：	{title: '线索来源', field: 'source', filterName: 'lov', formFilter: true, lov: 'CLUE_SOURCE'}
			*  值列表的其他属性都写在 externalData 里面：
			*  {title: '线索来源', field: 'source', filterName: 'lov', formFilter: true, lov: 'CLUE_SOURCE',externalData:{excludeLov:['OTHER_PLACE']}}
			*  筛选时间：{title: '创建时间', field: 'created', filterName: 'date', formFilter: true}
			*  筛选数字：{title: '数字', field: 'mobilePhone', filterName: 'number', formFilter: true}
			*/
			externalFilterColumns: null,																	// 额外的筛选选项

            /*部分字段更新*/
            onlyUpdateChangeField:null,                                                                     //发送请求是否只更新被修改的字段
            forceUpdateFields:[],                                                                           //启用onlyUpdateChangeField属性时，强制要更新的字段数组

            /*快速筛选参数*/
            quickfilterOption: [],                                                                         //快速筛选自定义选项

            quickfilterValue: [],                                                                          //快速筛选
            quickfilterDefaultValue:null,                                                                  //快速筛选默认值,与quickfilterValue同时使用，比如现在需要设置字段followStatus的默认快速筛选为"cancel"，多选情况下，两个属性值为
                                                                                                           // quickfilterValue: [{property: 'followStatus', value: 'cancel', operator: '=',}]，格式为filtersRaw数组
                                                                                                           // quickfilterDefaultValue: [{field: 'followStatus', val: ['cancel'],}], ，格式为快速筛选defaultValue属性值所支持的格式
            quickfilterType: null,                                                                         //快速筛选类型
            quickfilterOptions: [],                                                                        //快速筛选

            /*---------------------------------------请求时是否需要将参数格式化为表单形式-------------------------------------------*/
            formatFormParamSetting: {
                queryByExamplePage: true,
                queryCount: true,
                exportData: true,
                insert: false,
                update: false,
                deleteById: false,
                batchInsert: false,
                batchUpdate: false,
            },

            /**
             * 一下属性为不可配置的属性
             * @author weishengjian
             * @date 2018/11/21
             */
            /*---------------------------------------auto-table自身属性汇总-------------------------------------------*/
            tableCreated: false,                                                                           //AutoTable是否已经创建
            loading: false,                                                                                //是否正在加载数据
            list: [],
            _count: null,                                                                                  //每次请求得到的count
            fillRows: null,                                                                                //自动填满父元素时，显示的行数
            _initOption: {},                                                                               //开发者的原始option
            defaultOptionName: null,                                                                       //加载默认option的名称
            pageData,
            dataChunks:[],
            tableStatus:EDIT_STATUS.NORMAL,
            pageBackup:{},                                                                                 //分页查询数据之前，用来缓存一些状态数据
            cancelQueryPageRequest:()=>null,                                                               //是一个函数，调用之后会取消分页查询请求
            cancelable:null,                                                                               //当前请求是否可以取消，只有分页查询请求才能取消

            /*---------------------------------------筛选相关-------------------------------------------*/
            /*通用筛选配置参数，搜索栏，表单查询，列筛选*/
            linkFilterOptions:null,

            /*搜索栏单字段筛选(包括全字段筛选)*/
            singleDynamicFilter: null,                                                                     //（单字段筛选）字段查询筛选条件，虽然这里是单子段，但是这里这个变量也有可能是一个数组
            /*表单筛选参数*/
            formDynamicFilterList:null,                                                                    // 表单筛选参数
            /*自定义筛选,在setFilter以及removeFilter中设置*/
            customFilters: [],                                                                             //（自定义筛选）
            /*组合查询筛选*/
            combineFilter: {
                filtersRaw: [],                                                                            //（组合筛选）筛选对话框中获取的用来查询的筛选参数数组
                filterOptions: [],                                                                         //（组合筛选）筛选配置参数
                filterResults: [],                                                                         //（组合筛选）缓存的筛选对话框中已经存在的数据
				filterOperator:'',																		   // 组合查询逻辑表达式
            },
            /*列筛选排序*/
            columnParams:{},                                                                               //列筛选，搜索条件
            /*收藏的查询*/
            storeFilter: {
                initialized: false,
                data: [],
            },
            /*----------------------------------------------------------------------------------*/
            /*当前得到的安全性*/
            security:null,
        }
    },
    computed: {
        /*@formatter:off*/
        selectRow() {if (this.selectIndex == null || this.selectIndex < 0) return null;return this.list[this.selectIndex]},

        _queryByExamplePage() {return this.queryByExamplePage || `${this.module}/queryByExamplePage`},
        _insertUrl() {return this.insert || `${this.module}/insert`},
        _updateUrl() {return this.update || `${this.module}/update`},
        _deleteByIdUrl() {return this.deleteById || `${this.module}/deleteById`},
        _queryCount() {return this.queryCount || this._queryByExamplePage},
        _exportData() {return this.exportData || `${this._queryByExamplePage}/exportData`},
        _batchInsert() {return this.batchInsert || `${this.module}/batchInsert`},
        _batchUpdate() {return this.batchUpdate || `${this.module}/batchUpdate`},
        rowNum(){return this.fillRows || this.showNum},
        /*@formatter:on*/
		lv_disabled() {

			/*如果父表没有数据，则禁用所有按钮*/
			if (!!this.parentOption && !this.parentOption.selectRow) return {
				insertable: true,
				updateable: true,
				deleteable: true,
				otherable: true,
			}

			const disabled = {
				insertable: false,
				updateable: false,
				deleteable: false,
				otherable: false,
			}

			/*没有设置disabled，则启动所有按钮*/
			if (this.disabled == null) return disabled

			let flag = typeof this.disabled === "function" ? this.disabled.apply(this.context, [this]) : !!this.disabled

			if (typeof flag === "object") {
				Object.assign(disabled, flag)
			} else {
				Object.assign(disabled, {
					insertable: flag,
					updateable: flag,
					deleteable: flag,
					otherable: flag,
				})
			}

			return disabled
		},
		/**
		 * 新建更新以及编辑控制
		 * @author  韦胜健
		 * @date    2019/4/25 20:55
		 */
		lv_enable() {
			let {insertable, updateable, deleteable} = this
			let otherable = true
			if (this.enable != null) {
				const ret = this.enable.apply(this.context, [this])
				ret.insertable != null && (insertable = ret.insertable)
				ret.updateable != null && (updateable = ret.updateable)
				ret.deleteable != null && (deleteable = ret.deleteable)
				ret.otherable != null && (otherable = ret.otherable)
			}
			return {insertable, updateable, deleteable, otherable}
		},
		/**
		 * 根据字段映射linkFilterOptions，用来获取某一个字段的linkFilterOption
		 * @author  韦胜健
		 * @date    2019/9/28 18:00
		 */
		lv_linkFilterOptionsMap() {
			if (!this.linkFilterOptions) return {}
			return this.linkFilterOptions.reduce((ret, item) => {
				ret[item.field] = item
				return ret
			}, {})
		},

		/**
		 * 快速筛选的option
		 * @author  韦胜健
		 * @date    2019/4/25 20:54
		 */
		lv_quickfilterOption() {
			const quickfilterOption = this.quickfilterOption || []
			const quickfilterOptions = this.quickfilterOptions || []
			const ret = [...quickfilterOption, ...quickfilterOptions]
			return ret.length > 0 ? ret : null
		}

	},
	methods: {
		/**
		 * 加载数据
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async load(isReload = false) {

			if (!!this.parentOption && !this.parentOption.selectRow) {
				this.list.splice(0, this.list.length)
				this.pageData.page = 1
				this.pageData.total = 1
				this.pageData.noMore = true
				this.changeSelectRow(null)
				return
			}

			if (this.tableStatus !== EDIT_STATUS.NORMAL && this.tableStatus !== EDIT_STATUS.SELECT) {
				const table = this.getTable()
				!!table && await table.lv_cancel()
			}

			const requestOption = {
				url: this._queryByExamplePage,
				param: await this.getQueryParam(),
				requestMethod: this.requestMethod,
				formatFormParam: this.formatFormParamSetting.queryByExamplePage,
				isReload,
				requestType: REQUEST_TYPE.queryByExamplePage,
			}
			if (!!this.countOnReload && isReload) requestOption.param.totalFlag = true
			!!this.beforeLoad && (await this.beforeLoad.apply(this.context, [requestOption]))
			const data = await this._request(requestOption, true);
			const {rows, success, total} = data
			if (data.total == null) {
				console.error('分页查询返回结果中没有total字段，请检查！(total与success，rows平级)')
			}
			!!this.afterLoad && this.afterLoad.apply(this.context, [rows, requestOption, data])

			this._executeRowFormatter(rows, 'afterLoad')

			const dataChunks = this.context.$lv.$utils.chunk(rows, (this.rowNum - 0) + 10)
			if (dataChunks.length > 1 && this.chunkLoadData) {
				this.dataChunks = dataChunks
				await this._loadDataChunk(false, true)
			} else {
				// console.log('load data')
				// const startTime = new Date()
				// console.log(`startTime:${this.$lv.$utils.dateFormat(startTime, 'HH:mm:ss SSS')}`)
				this.dataChunks = []
				this.list = rows
				await this.$lv.nextTick()
				// const endTIme = new Date()
				// console.log(`endTIme:${this.$lv.$utils.dateFormat(endTIme, 'HH:mm:ss SSS')}`)
				// console.log(`duration:${endTIme.getTime() - startTime.getTime()}`)
			}

			this.pageData.showPage = this.pageData.page
			if (!this.pageData.noMore) {
				this.pageData.noMore = !!requestOption.param.totalFlag || total !== (requestOption.param.page) * requestOption.param.rows + 1
				this.pageData.total = total
			}

			if (this.list.length === 0) {
				this.changeSelectRow(null)
			} else if (!!this.selectFirstOnLoad) {
				this.changeSelectRow(0)
			}
			return {rows, success, total};
		},

		/**
		 * 重新加载数据
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async reload(page = 1) {
			this.param.page = page;
			this.pageData.noMore = false
			this.pageData.total = 1
			return await this.load(true);
		},

		/**
		 * 打开筛选对话框
		 * @author  韦胜健
		 * @date    2018/12/4 18:45
		 *
		 * in:
		 * filterOptions                //用来渲染组合查询的字段下来选项
		 * filterResults                //组合查询对话框的渲染行的数据，打开的时候需要用这个重新渲染行
		 *
		 * out:
		 * filtersRaw                   //组合查询格式化得到的查询参数
		 * filterResults                //同上filtersResult
		 *
		 */
		showFilter() {
			$filter.pick({
				context: this.context,
				interfacePath: this._queryByExamplePage,
				filterOptions: this.combineFilter.filterOptions,
				filterResults: this.combineFilter.filterResults,
				onConfirm: (filtersRaw, filterResults, filterOperator) => {
					// console.log({filtersRaw, filterResults, filters,filterOptions:this.filterOptions})
					this.combineFilter.filtersRaw = LinkUtils.deepCopy(filtersRaw)
					this.combineFilter.filterResults = LinkUtils.deepCopy(filterResults)
					this.combineFilter.filterOperator = LinkUtils.deepCopy(filterOperator)
					this.reload()
				},
				onSave: () => {
					this.storeFilter.initialized = false
				}
			})
		},
		/**
		 * 跳转到组合查询管理页面
		 * @author  姚润发
		 * @date    2021/03/01
		 */
		gotoFilterMangerPage() {
			const tabData = this.context.pageTabData || {};
			const tabOption = {
				id: `${tabData.id}#filters`,
				title: `${tabData.title || this.title}-组合查询列表`,
				path: `/${this.context.$linkModule}/crm/combine_filter/combine_filter_list/combine-filter.vue`,
				param: {interfacePath: this._queryByExamplePage}
			}
			this.context.$nav.openTab(tabOption, true);
		},
		/**
		 * 设置隐藏筛选条件
		 * @author  韦胜健
		 * @date    2019/1/2 10:16
		 * @param id            筛选条件的id
		 * @param value         筛选条件的值
		 * @param property      筛选条件的属性
		 * @param operator      筛选条件的操作符
		 * @param isDate        筛选参数是否在后台需要格式化为日期类型
		 */
		setFilter(id, value, property, operator, isDate = false) {
			if (!id) {
				console.error('设置隐藏筛选条件的时候，id不能为空！')
				return
			}
			/*如果筛选条件已经存在，则修改已有的筛选条件*/
			for (let i = 0; i < this.customFilters.length; i++) {
				const customFilter = this.customFilters[i];
				if (customFilter.id === id) {
					value != null && (customFilter.value = value)
					property != null && (customFilter.property = property)
					operator != null && (customFilter.operator = operator)
					isDate != null && (customFilter.type = isDate ? 'date' : null)
					return customFilter
				}
			}
			/*如果筛选条件不存在，则插入新的筛选条件*/
			const filtersRaw = {
				property: property || id,
				value,
				id,
				operator: operator || '=',
				type: isDate ? 'date' : null
			}
			this.customFilters.push(filtersRaw)
			return filtersRaw
		},

		/**
		 * 移除隐藏筛选条件
		 * @author  韦胜健
		 * @date    2019/1/2 10:29
		 * @param id 筛选条件的id
		 */
		removeFilter(id) {
			if (!id) {
				console.error('设置隐藏筛选条件的时候，id不能为空！')
				return false
			}
			for (let i = 0; i < this.customFilters.length; i++) {
				const customFilter = this.customFilters[i];
				if (customFilter.id === id) {
					this.customFilters.splice(i, 1)
					return true
				}
			}
			return false
		},

		/**
		 * 上一页
		 * @author  韦胜健
		 * @date    2019/4/8 20:18
		 */
		async prevPage() {
			if (this.pageData.page - 1 < 1) return
			this._savePageStatus()
			this.pageData.page--
			await this.load()
		},

		/**
		 * 下一页
		 * @author  韦胜健
		 * @date    2019/4/8 20:18
		 */
		async nextPage() {
			if (this.pageData.page + 1 > this.pageData.totalPage) return;
			this._savePageStatus()
			this.pageData.page++;
			await this.load()
		},

		/**
		 * 跳转到指定页
		 * @author  韦胜健
		 * @date    2019/4/8 20:18
		 */
		async jumpPage(targetPage) {
			const val = (targetPage || 1) - 0
			this._savePageStatus()
			const next = async (v) => {
				this.pageData.page = 1
				await this.context.$lv.nextTick()
				this.pageData.page = v
				await this.load()
			}
			if (val < 1) {
				next(1);
			} else if (val > this.pageData.totalPage) {
				if (!this.pageData.noMore) {
					await this._requestTotalCount();
					const totalPage = Math.ceil(this.pageData.total / this.pageData.pageSize);
					this.context.$nextTick(() => next(val > totalPage ? totalPage : val));
				} else next(this.pageData.totalPage);
			} else next(val);
		},

		/**
		 * 获取当前使用AutoOption的table
		 * @author  韦胜健
		 * @date    2019/8/14 14:43
		 */
		getTable() {
			return AutoTableController.getTable(this)
		},

		/**
		 * 修改当前选中行
		 * @author  韦胜健
		 * @date    2019/8/14 14:43
		 */
		changeSelectRow(index) {
			const table = this.getTable()
			!!table && table.changeSelectRow(index)
		},

		/**
		 * 是否存在父表正在编辑
		 * @author  韦胜健
		 * @date    2019/6/29 17:48
		 */
		hasParentEditing() {
			let option = this
			do {
				if (option.tableStatus != null && option.tableStatus !== EDIT_STATUS.NORMAL) {
					return true
				} else {
					option = option.parentOption
				}
			} while (!!option)

			return false
		},

		/**
		 * 获取查询参数
		 * @author  韦胜健
		 * @date    2019/9/28 10:25
		 */
		async getQueryParam() {
			/*从option的param参数中复制一份*/
			let ret = this.$lv.$utils.deepCopy(this.param)
			if (this.$lv.$utils.typeOf(this._initOption.param) === 'function') {
				ret = Object.assign({}, ret, await this._initOption.param.apply(this.context))
			}

			/**
			 * 1、当参数中没有配置安全性时，使用当前页面的安全性
			 * 2、ObjectService中无效，因为在获取targetParam之前，会先执行_loadDefaultOption，_loadDefaultOption在ObjectService中是不会初始化安全性参数的；
			 *    _loadDefaultOption之后，option中的security才初始化；
			 * @author  韦胜健
			 * @date    2019/6/19 17:16
			 */
			if (!ret.hasOwnProperty('oauth') && !!this.security && !!this.security.oauth) ret.oauth = this.security.oauth
			/*设置排序参数*/
			if (ret.sort == null) ret.sort = this.sortField
			if (ret.order == null) ret.order = this.sortDesc ? 'desc' : 'asc'

			if (ret.page == null) ret.page = this.pageData.page
			if (ret.rows == null) ret.rows = this.pageData.pageSize

			/*---------------------------------------筛选参数-------------------------------------------*/

			const queryFiltersRaw = {}
			queryFiltersRaw.paramFiltersRaw = ret.filtersRaw || []                                                                               //参数中原本的筛选参数
			queryFiltersRaw.customFiltersRaw = LinkUtils.deepCopy(this.customFilters) || [];                                                               //自定义筛选
			queryFiltersRaw.parentFiltersRaw = this._parentQueryParam || [];                                                                     //父表筛选
			queryFiltersRaw.quickFiltersRaw = !!this.quickfilterValue ? LinkUtils.deepCopy(this.quickfilterValue) : []                                     //快速筛选
			queryFiltersRaw.formFiltersRaw = !!this.formFiltersRaw ? LinkUtils.deepCopy(this.formFiltersRaw) : []                                          //表单查询
			//搜索栏筛选
			if (!!this.singleDynamicFilter) {
				if (!!this.singleDynamicFilter.field) {
					//单字段筛选
					queryFiltersRaw.singleFiltersRaw = await this.singleDynamicFilter.toFiltersRaw()
				} else {
					//全字段筛选
					queryFiltersRaw.allFiltersRaw = await this.singleDynamicFilter.toFiltersRaw(this)
				}
				// console.log(!!this.singleDynamicFilter.field, queryFiltersRaw.allFiltersRaw)
			}
			//表单查询
			if (!!this.formDynamicFilterList && this.formDynamicFilterList.length > 0) {
				queryFiltersRaw.formFiltersRaw = []
				for (let i = 0; i < this.formDynamicFilterList.length; i++) {
					const dynamicFilter = this.formDynamicFilterList[i];
					queryFiltersRaw.formFiltersRaw.push(...await dynamicFilter.toFiltersRaw())
				}
			}
			//列筛选
			const fields = Object.keys(this.columnParams)
			if (fields.length > 0) {
				const columnFiltersRaw = []
				for (let i = 0; i < fields.length; i++) {
					const field = fields[i];
					const columnParam = this.columnParams[field]
					if (!!columnParam.searchDynamicFilter) columnFiltersRaw.push(...(await columnParam.searchDynamicFilter.toFiltersRaw()))
					if (!!columnParam.linkSelectFilterData && columnParam.linkSelectFilterData.length > 0) columnFiltersRaw.push({
						property: field,
						operator: 'in',
						value: `[${columnParam.linkSelectFilterData.map(({value}) => value).join(',')}]`
					})
				}
				queryFiltersRaw.columnFiltersRaw = columnFiltersRaw
			}

			/*给所有的filtersRaw设置id*/
			// console.log(queryFiltersRaw)
			Object.keys(queryFiltersRaw).forEach(key => queryFiltersRaw[key].forEach((filtersRaw, index) => (filtersRaw.id = `${filtersRaw.id || key}_${index}`)))

			let totalFiltersRaw = [].concat([
				...queryFiltersRaw.paramFiltersRaw,
				...queryFiltersRaw.customFiltersRaw,
				...queryFiltersRaw.parentFiltersRaw,
				...queryFiltersRaw.quickFiltersRaw,
				...(queryFiltersRaw.formFiltersRaw || []),
				...(queryFiltersRaw.singleFiltersRaw || []),
				...(queryFiltersRaw.columnFiltersRaw || []),
			])

			let filterOperatorArray = []
			let totalFiltersRawIdsExcludeAllFiltersRawIds = totalFiltersRaw.map(item => item.id)

			/*全字段查询表达式*/
			if (!!queryFiltersRaw.allFiltersRaw && queryFiltersRaw.allFiltersRaw.length > 0) {
				const allFiltersRawIds = queryFiltersRaw.allFiltersRaw.map(item => item.id)
				const operator = `( ${allFiltersRawIds.join(' or ')} )`
				filterOperatorArray.push(operator)
				totalFiltersRaw = totalFiltersRaw.concat(queryFiltersRaw.allFiltersRaw)
				// console.log('all', operator)
			}
			/*组合查询（可能有表达式）*/
			if (!!this.combineFilter.filtersRaw && this.combineFilter.filtersRaw.length > 0) {
				let {filtersRaw, filterOperator} = this.combineFilter
				totalFiltersRaw.push(...filtersRaw)
				if (!!filterOperator) {
					filterOperatorArray.push(`( ${filterOperator} )`)
					// console.log('combine', this.combineFilter.filterOperator)
				}
			}
			/*其他筛选条件*/
			if (filterOperatorArray.length > 0 && totalFiltersRawIdsExcludeAllFiltersRawIds.length > 0) {
				filterOperatorArray.push(`( ${totalFiltersRawIdsExcludeAllFiltersRawIds.join(' and ')} )`)
				// console.log('filters', filterOperatorArray[filterOperatorArray.length - 1])
			}
			ret.filtersRaw = totalFiltersRaw;
			filterOperatorArray.length > 0 && (ret.filterOperator = `( ${filterOperatorArray.join(' and ')} )`);

			// console.log({...queryFiltersRaw}, ret)
			return ret
		},

		/**
		 * 设置搜索栏的搜索值
		 * @author  韦胜健
		 * @date    2019/12/30 20:07
		 */
		setSingleFilter(linkFilterOption) {
			this.searchField = linkFilterOption.field
			this.singleDynamicFilter = new DynamicFilter(linkFilterOption, this.context)
		},

		/*---------------------------------------一下为不可调用函数-------------------------------------------*/
		_loadDataChunk(all = false, resetList = false) {
			if (!this.dataChunks || this.dataChunks.length === 0) return
			this.loading = true
			this.disabledBodyScroll = true
			return new Promise((rs) => {
				setTimeout(async () => {
					// console.log('_loadDataChunk')
					// const startTime = new Date()
					// console.log(`startTime:${this.$lv.$utils.dateFormat(startTime, 'HH:mm:ss SSS')}`)
					if (!!resetList) {
						this.list = []
					}
					if (!all) {
						const chunk = this.dataChunks.shift()
						this.list.push(...chunk)
					} else {
						this.dataChunks.forEach(chunk => this.list.push(...chunk))
						this.dataChunks = []
					}
					await this.context.$lv.nextTick()
					// const endTIme = new Date()
					// console.log(`endTIme:${this.$lv.$utils.dateFormat(endTIme, 'HH:mm:ss SSS')}`)
					// console.log(`duration:${endTIme.getTime() - startTime.getTime()}`)
					this.loading = false
					setTimeout(() => {
						this.disabledBodyScroll = false
					}, 50)
					rs()
				}, 0)
			})
		},

		/**
		 * 处理双击事件，注意这里也是会触发单击事件的，而且会触发两次click事件
		 * @author  韦胜健
		 * @date    2018/12/19 16:45
		 */
		_dblclick({row, rowIndex}) {
			!!this.dblclick && this.dblclick.apply(this.context, [row, rowIndex])
		},

		/**
		 * 表格状态变化处理
		 * @author  韦胜健
		 * @date    2019/8/14 14:28
		 */
		_onTableStatusChange(tableStatus) {
			if (this.tableStatus === tableStatus) return
			this.tableStatus = tableStatus
			this.$emit('statusChange', tableStatus)
		},
		/**
		 * 表格选中行变化处理
		 * @author  韦胜健
		 * @date    2019/8/14 14:28
		 */
		_onTableSelectChange(index) {
			this.$emit('selectChange', index)
			!!this.click && this.click.apply(this.context, [index == null ? null : this.list[index], index])
		},

		/**
		 * 查询总数
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async _requestTotalCount() {
			const queryParam = await this.getQueryParam()
			queryParam.onlyCountFlag = true
			const requestOption = {
				param: queryParam,
				url: this._queryCount,
				requestType: REQUEST_TYPE.queryCount,
				formatFormParam: this.formatFormParamSetting.queryCount,
			}
			!!this.beforeLoad && (await this.beforeLoad.apply(this.context, [requestOption]))
			const {rows: [{total}]} = await this._request(requestOption)
			this.pageData.total = total
			this.pageData.noMore = true
		},

		// reloadChildren() {
		// }

		/**
		 * 发送创建记录请求
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async _requestInsert(row) {
			row = this._formatRow(row)
			!!this.beforeInsert && await this.beforeInsert.apply(this.context, [row])
			!!this.beforeUpsert && await this.beforeUpsert.apply(this.context, [row])
			const param = Object.assign({row_status: "NEW"}, row)
			const data = await this._request({
				url: this._insertUrl,
				param,
				formatFormParam: this.formatFormParamSetting.insert,
				requestType: REQUEST_TYPE.insert,
			});
			if (data.newRow == null) {
				throw new Error('insert接口没有返回newRow字段，请检查')
			}
			this._executeRowFormatter(data.newRow, 'afterInsert')
			!!this.afterInsert && await this.afterInsert.apply(this.context, [row, data])
			!!this.afterUpsert && await this.afterUpsert.apply(this.context, [row, data])
			this.pageData.total++
			this.pageData.noMore = false
			return data.newRow
		},

		/**
		 * 批量插入数据
		 * @author  韦胜健
		 * @date    2019/1/10 09:14
		 */
		async _requestBatchInsert(rows) {
			const paramRows = LinkUtils.deepCopy(rows)
			for (let i = 0; i < paramRows.length; i++) {
				const row = paramRows[i] = this._formatRow(paramRows[i]);
				if (!!this.beforeInsert) await this.beforeInsert.apply(this.context, [row])
				if (!!this.beforeUpsert) await this.beforeUpsert.apply(this.context, [row])
				row.row_status = 'NEW'
			}
			let {result} = await this._request({
				url: this._batchInsert,
				param: paramRows,
				formatFormParam: this.formatFormParamSetting.batchInsert,
				requestType: REQUEST_TYPE.batchInsert,
			});
			if (result == null) {
				throw new Error('批量新建接口没有返回result')
			}
			const param = {
				page: 1,
				rows: rows.length,
				pageFlag: true,
				filtersRaw: [{
					id: 'id',
					property: 'id',
					operator: 'in',
					value: `[${result.map(item => item.id).join(',')}]`
				}],
				sort: 'created',
				order: 'desc',
				onlyCountFlag: false,
				oauth: 'ALL',
			}
			let {rows: newRows} = await this.context.$http.post(this._queryByExamplePage, param, this.formatFormParamSetting.queryByExamplePage)
			this._executeRowFormatter(newRows, 'afterBatchInsert')
			newRows.forEach(async (newRow, index) => {
				!!this.afterInsert && await this.afterInsert.apply(this.context, [rows[index], newRow])
				!!this.afterUpsert && await this.afterUpsert.apply(this.context, [rows[index], newRow])
			})
			this.pageData.total += newRows.length
			this.pageData.noMore = false
			return newRows
		},

		/**
		 * 发送更新请求
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async _requestUpdate(row) {
			row = this._formatRow(row)
			!!this.beforeUpdate && await this.beforeUpdate.apply(this.context, [row])
			!!this.beforeUpsert && await this.beforeUpsert.apply(this.context, [row])
			const param = Object.assign({row_status: "UPDATE"}, row)
			if (!!this.onlyUpdateChangeField) param.updateFields = Object.keys(param).join(',')
			const data = await this._request({
				url: this._updateUrl,
				param,
				formatFormParam: this.formatFormParamSetting.update,
				requestType: REQUEST_TYPE.update,
			});
			if (data.newRow == null) {
				throw new Error('update接口没有返回newRow字段，请检查')
			}
			this._executeRowFormatter(data.newRow, 'afterUpdate')
			!!this.afterUpdate && await this.afterUpdate.apply(this.context, [row, data])
			!!this.afterUpsert && await this.afterUpsert.apply(this.context, [row, data])
			// console.log(data)
			return data.newRow
		},
		/**
		 * 分页查询之前，保存一些页状态数据
		 * @author  韦胜健
		 * @date    2019/9/11 15:52
		 */
		_savePageStatus() {
			this.pageBackup.page = this.pageData.page
			this.pageBackup.pageSize = this.pageData.pageSize
		},
		/**
		 * 分页查询取消的时候，重置一些状态数据
		 * @author  韦胜健
		 * @date    2019/9/11 15:52
		 */
		_revertPageStatus() {
			if (!!this.pageBackup.page) this.pageData.page = this.pageBackup.page
			if (!!this.pageBackup.pageSize) this.pageData.pageSize = this.pageBackup.pageSize
		},
		/**
		 * 批量更新数据
		 * @author  韦胜健
		 * @date    2019/1/10 14:01
		 */
		async _requestBatchUpdate(rows) {
			const paramRows = LinkUtils.deepCopy(rows)
			for (let i = 0; i < paramRows.length; i++) {
				const row = paramRows[i] = this._formatRow(paramRows[i]);
				if (!!this.beforeUpdate) await this.beforeUpdate.apply(this.context, [row])
				if (!!this.beforeUpsert) await this.beforeUpsert.apply(this.context, [row])
				row.row_status = 'UPDATE'
				if (!!this.onlyUpdateChangeField) row.updateFields = Object.keys(row).join(',')
			}
			const {result: newRows} = await this._request({
				url: this._batchUpdate,
				param: paramRows,
				formatFormParam: this.formatFormParamSetting.batchUpdate,
				requestType: REQUEST_TYPE.batchUpdate,
			});
			if (newRows == null) {
				throw new Error('batchUpdate接口没有返回result字段，请检查')
			}
			this._executeRowFormatter(newRows, 'afterBatchUpdate')
			newRows.forEach(async (newRow, index) => {
				!!this.afterUpdate && await this.afterUpdate.apply(this.context, [rows[index], newRow])
				!!this.afterUpsert && await this.afterUpsert.apply(this.context, [rows[index], newRow])
			})
			return newRows
		},

		/**
		 * 发送删除记录请求
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		async _requestDelete(row) {
			row = this._formatRow(row)
			!!this.beforeDelete && await this.beforeDelete.apply(this.context, [row])
			const data = await this._request({
				url: this._deleteByIdUrl,
				param: row,
				formatFormParam: this.formatFormParamSetting.deleteById,
				requestType: REQUEST_TYPE.deleteById,
			});
			!!this.afterDelete && await this.afterDelete.apply(this.context, [row, data])
			this.pageData.noMore = false
			return data
		},

		/**
		 * 导出数据
		 * @author  韦胜健
		 * @date    2018/12/12 14:15
		 */
		async _requestExportData(option) {
			const requestOption = {
				url: this._exportData,
				param: Object.assign({}, await this.getQueryParam(), option),
				formatFormParam: this.formatFormParamSetting.queryByExamplePage,
				requestType: REQUEST_TYPE.exportData,
			}
			!!this.beforeExportData && (await this.beforeExportData.apply(this.context, [requestOption]))
			!!this.beforeLoad && (await this.beforeLoad.apply(this.context, [requestOption]))
			const {success, url} = await this._request(requestOption);
			!!this.afterExportData && (await this.afterExportData.apply(this.content, [requestOption, success, url]))
			!!success && (window.location.href = url)
		},

		/**
		 * 发送post请求
		 * @author 韦胜健
		 * @date 2018/11/22
		 */
		async _request({url, param, formatFormParam = true, requestMethod = 'post', requestType}, cancelable = false) {
			this.loading = true
			this.cancelable = cancelable
			let data;
			try {
				if (!!this.requestFunc) {
					// console.log('requestFunc')
					data = await this.requestFunc.apply(this.context, [url, param, formatFormParam, requestMethod, requestType])
				} else {
					const config = {}
					const promise = this.context.$http.request(url, param, formatFormParam, requestMethod, config)
					this.cancelQueryPageRequest = () => {
						/*取消分页查询，重置一些状态数据*/
						this._revertPageStatus()
						config.cancel()
					}
					data = await promise
				}
				if (!data.success) {
					const msg = data.result || data.message || data.msg || '系统错误！';
					this.context.$nav.error(msg)
					console.error(`AutoOption Error:`, msg)
					return Promise.reject(msg)
				} else
					return Promise.resolve(data)
			} catch (e) {

				/*如果不是取消请求的报错，才打印显示到对话框*/
				if (!this.context.$http.isCancel(e)) {
					let msg = e.message
					console.error(`AutoOption Error:`, e)
					if (msg === '网络异常') {
						const relogin = () => {
							linkToken.logout()
							dialog.hide()
						}
						const dialog = Vue.prototype.$dialog.show({
							message: '网络异常',
							footLeftRender: (h) => (<link-button label="重新登录" onClick={() => relogin()}/>)
						})
					} else {
						this.context.$nav.error(msg)
					}
				}
				throw e
			} finally {
				this.loading = false
				this.cancelQueryPageRequest = () => null
			}
		},

		/**
		 * 格式化参数
		 * @author  韦胜健
		 * @date    2018/12/1 14:19
		 * @param row 要格式化的参数
		 */
		_formatRow(row) {
			/*const excludeKey = ['lv_id', '_index']
			const copyRow =LinkUtils.deepCopy(row)
			Object.keys(copyRow).forEach(key => excludeKey.indexOf(key) > -1 && (delete copyRow[key]))*/
			return LinkUtils.deepCopy(row)
		},

		/**
		 * 格式化返回的row数据
		 * @author  韦胜健
		 * @date    2019/2/18 10:26
		 */
		_executeRowFormatter(data, type) {
			if (!this.rowFormatter) return
			if (LinkUtils.typeOf(data) === 'array') {
				data.forEach(itemData => this.rowFormatter.apply(this.context, [itemData, type]))
			} else {
				this.rowFormatter.apply(this.context, [data, type])
			}
		},

		/**
		 * 加载默认参数
		 * @author weishengjian
		 * @date 2018/11/22
		 */
		_loadDefaultOption(tag) {
			if (!!this.defaultOptionName) return
			this.defaultOptionName = tag
			let option = this.context.$lv.$utils.deepCopy(Object.assign({}, AutoOption.getDefaultPublicOption(), tag === 'auto-table' ? DEFAULT_OPTION_AUTO_TABLE : DEFAULT_OPTION_OBJECT_PICK))

			if (tag === 'auto-table') {
				const {security} = getSecurity(this.context)
				if (security.defaultNoQueryFlag === 'Y') option.loadOnStart = false
				if (security) {
					this.security = security
					security.addFlag != null && (option.insertable = security.addFlag === 'Y')
					security.editFlag != null && (option.updateable = security.editFlag === 'Y')
					security.deleteFlag != null && (option.deleteable = security.deleteFlag === 'Y')
					security.exportFlag != null && (option.exportable = security.exportFlag === 'Y')
					security.importFlag != null && (option.importable = security.importFlag === 'Y')
					if (security.readonlyFlag === 'Y') {
						option.insertable = false
						option.updateable = false
						option.deleteable = false
						option.copyable = false
						option.importable = false

						option.fastRender = true
					}
				}
			}
			// console.log('_loadDefaultOption', tag, option)
			Object.keys(option).forEach(key => this[key] == null && (this[key] = option[key]))

			if (this.pageData.pageSize == null) {
				this.pageData.pageSize = this.showNum
			}
			if (option.sizeOption.indexOf(this.pageData.pageSize) === -1) {
				option.sizeOption.unshift(this.pageData.pageSize)
			}
		},
	}
}

export class AutoOption extends Vue {

	static DEFAULT_FORMAT_PARAM_SETTING = DEFAULT_FORMAT_PARAM_SETTING              //标准接口请求类型，表单请求还是json请求
	static DEFAULT_QUERY_PARAM = DEFAULT_QUERY_PARAM                                //默认查询参数
	static getDefaultPublicOption = getDefaultPublicOption                          //AutoTable以及$object默认公共参数
	static DEFAULT_OPTION_AUTO_TABLE = DEFAULT_OPTION_AUTO_TABLE                    //AutoTable默认参数
	static DEFAULT_OPTION_OBJECT_PICK = DEFAULT_OPTION_OBJECT_PICK                  //$object默认参数

	/**
	 * 默认新行属性
	 * @author  韦胜健
	 * @date    2018/12/20 11:20
	 */
	async _defaultNewRow() {
		let defaultNewRow = {}
		if (!!this.defaultNewRowUrl) {
			const data = await this._request({
				url: this.defaultNewRowUrl,
				formatFormParam: true,
				requestType: REQUEST_TYPE.defaultNewRow,
			})
			defaultNewRow = data.result
		} else if (!!this.defaultNewRow) {
			defaultNewRow = this.$lv.$utils.typeOf(this.defaultNewRow) === 'function' ? (await this.defaultNewRow.apply(this.context)) : this.defaultNewRow
		}

		const parentProperties = {}
		const parentSelectRow = !!this.parentOption ? this.parentOption.selectRow : null
		if (!!this.parentOption && !!parentSelectRow) {
			Object.keys(this.map).forEach(key => parentProperties[key] = parentSelectRow[this.map[key]])
		}

		return this._formatRow(Object.assign({}, defaultNewRow || {}, parentProperties))
	}

	/**
	 * 根据父子表映射规则生成的筛选参数
	 * @author  韦胜健
	 * @date    2018/12/19 18:07
	 */
	get _parentQueryParam() {
		const ret = []
		if (!this.map || !this.parentOption || !this.parentOption.selectRow) return ret

		Object.keys(this.map).forEach(key => {
			const value = this.parentOption.selectRow[this.map[key]]
			ret.push({
				id: key,
				property: key,
				// operator: '=',
				value: value == null ? '' : value
			})
		})
		return ret
	}

	constructor(option) {
		super(component)

		if (!option.context) {
			console.error('AutoOption的所属上下文context不能为空！')
			return
		}
		Object.assign(this, option);
		this._initOption = option
		this.param = Object.assign({}, LinkUtils.deepCopy(DEFAULT_QUERY_PARAM), option.param);
		if (!!option.param) {
			if (!!option.param.sort) this.sortField = option.param.sort
			if (!!option.param.order) this.sortDesc = option.param.order === 'desc'
		}

		if (this.showNum == null) {
			if (!!this._initOption && !!this._initOption.param && !!this._initOption.param.rows) {
				this.showNum = this._initOption.param.rows
			}
		} else {
			if (this.param.rows == null) {
				this.param.rows = this.showNum
			}
		}

		this.formatFormParamSetting = Object.assign({}, LinkUtils.deepCopy(DEFAULT_FORMAT_PARAM_SETTING), option.formatFormParamSetting)

		const handler = {
			onSelectChange: () => {
				/*如果当前option所属表格没有并且没有强制查询数据，则直接返回*/
				if (!this.defaultOptionName) return
				this.reload()
				if (this.tableStatus !== EDIT_STATUS.NORMAL) {
					const table = this.getTable()
					if (!!table) table.lv_cancel()
				}
			},
			onStatusChange: () => {
				if (this.tableStatus !== EDIT_STATUS.NORMAL) {
					const table = this.getTable()
					if (!!table) table.lv_cancel()
				}
				this.$emit('statusChange')
			}
		}

		if (!!this.parentOption) {
			this.parentOption.$on('selectChange', handler.onSelectChange)
			this.parentOption.$on('statusChange', handler.onStatusChange)


			option.context.$on('hook:beforeDestroy', () => {
				this.parentOption.$off('selectChange', handler.onSelectChange)
				this.parentOption.$off('statusChange', handler.onStatusChange)
			})
		}
	}
}
